<template>
    <div :class="contentClass" class="text-right">
        <r-button size="small" @click="cancelFilter" class="inline-s">Cancel</r-button>
        <r-button type="primary" size="small" @click="applyFilter">Apply</r-button>
    </div>
</template>

<script>
    import BaseFilterMixin from '@/modules/rules-engine/components/condition-builder/filters/base-filter-mixin';

    export default {
        name: 'filter-footer',
        mixins: [BaseFilterMixin],
        methods: {
            applyFilter() {
                this.$emit('apply-filter');
            },
            cancelFilter() {
                this.$emit('cancel-filter');
            },
        },
    };
</script>

<style scoped>

</style>
